// TODO: Same as loadAcademicPlanCommand Deprecate and delete.

import { IDefineCommand } from 'core-ts-types';
import * as _4 from 'lodash';
import { FeedbackSuggestedPlanModel, IFeedbackSuggestedPlanModel } from './../models/feedback_suggested_plan_model';

angular
  .module('capability-ng-academic-planner')
  .service(
    'loadAdvisorSuggestedPlanCommand',
    function loadAdvisorSuggestedPlanCommand(
      $http: ng.IHttpService,
      log: any,
      ngFeedbackSuggestedPlanModel: FeedbackSuggestedPlanModel,
      updatePlanDataHelper: ng.IServiceProviderFactory,
      defineCommandORM: IDefineCommand
    ) {
      return defineCommandORM('loadAdvisorSuggestedPlanCommand', (deferred, studentNk: string) => {
        $http
          .get(`reg/advisorplan`, {
            headers: {
              'student-id': studentNk
            }
          })
          .then((response: any) => {
            const previous_status = _4.get(ngFeedbackSuggestedPlanModel.read(), 'previous_status', '');
            ngFeedbackSuggestedPlanModel
              .clear()
              .write({ ...response.data.suggested_plan, previous_status } as IFeedbackSuggestedPlanModel);
            updatePlanDataHelper(response);
            deferred.resolve();
          })
          .catch((e: any) => {
            log.disable();
            deferred.reject(e);
            log.enable();
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/commands/load_advisor_suggested_plan_command.ts